import axios from "axios";
import {
  getToken,
  setToken,
  getUserDetails,
  getRefreshToken,
  logout,
} from "../../utils/helpers";

const user = getUserDetails();

export const baseURL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_BASE_URL
    : process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "Origin, Content-Type",
  },
});

// Helper for refresh
const refreshToken = async () => {
  try {
    const resp = await axios.post(`${baseURL}/refresh-token`, {
      entity_id: user?.id,
      refresh_token: getRefreshToken(),
    });
    console.log("Token refreshed:", resp.data);
    return resp.data;
  } catch (error) {
    console.warn("Refresh token failed:", error);
    throw error;
  }
};

// Attach token on every request
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = getToken();
    if (token) {
      config.headers["x-access-token"] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle expired tokens and other errors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // No response means network error or backend unreachable
    if (!error.response) {
      console.error("Network error:", error);
      return Promise.reject(error);
    }

    // Unauthorized (token expired)
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const resp = await refreshToken();

        if (!resp?.Token) {
          throw new Error("Invalid token response");
        }

        const newToken = resp.Token;
        setToken(newToken);
        originalRequest.headers["x-access-token"] = newToken;

        // Retry the original request
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error("Failed to refresh token:", refreshError);

        // Gracefully handle logout
        logout(); // clear tokens + user
        window.location.href = "/login"; // redirect to login
        return Promise.reject(refreshError);
      }
    }

    // For other 4xx/5xx errors
    return Promise.reject(error);
  }
);

export default axiosInstance;
